import React from 'react'

const LmsCourseType = () => {
  return (
    <div>
      
    </div>
  )
}

export default LmsCourseType
